import React, { ReactNode } from "react";
import { useHabitGridStyles } from "hooks/habits/useHabitGridStyles";
import { View, Text, StyleSheet } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { Badge } from "react-native-paper";
import { COLORS } from "styles";
import { Ionicons } from "@expo/vector-icons";

export const GenericHabitTitleRow = ({
  title,
  onPress,
  Icon,
  showBadge,
}: {
  title: string;
  onPress: () => void;
  Icon?: ReactNode;
  showBadge?: boolean;
}) => {
  const { COLUMN_WIDTH, fontSize } = useHabitGridStyles();

  return (
    <View style={styles.titleContainer}>
      <TouchableOpacity
        style={{
          height: COLUMN_WIDTH - 1,
          justifyContent: "center",
          paddingHorizontal: 8,
          paddingVertical: 4,
        }}
        onPress={onPress}
      >
        <Text
          style={[styles.titleText, { fontSize, lineHeight: fontSize * 1.3 }]}
          numberOfLines={2}
        >
          {title}
        </Text>
        <Ionicons
          name="ios-arrow-forward"
          size={16}
          color={COLORS.GRAY3}
          style={{
            position: "absolute",
            right: 14,
          }}
        />
      </TouchableOpacity>
      {Icon && (
        <View style={styles.iconContainer}>
          {showBadge && <Badge size={8} style={styles.badge} />}
          <TouchableOpacity onPress={onPress}>{Icon}</TouchableOpacity>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "relative",
  },
  titleText: {
    fontWeight: "bold",
    paddingRight: 12,
  },
  iconContainer: {
    position: "absolute",
    width: 22,
    height: 22,
    borderRadius: 50,
    right: -12,
    zIndex: 10,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    shadowColor: "black",
    shadowOpacity: 0.2,
    shadowRadius: 2,
    shadowOffset: { width: 1, height: 0 },
    elevation: 3,
  },
  titleContainer: {
    backgroundColor: "white",
    justifyContent: "center",
    borderTopWidth: 1,
    borderColor: COLORS.GRAY1,
  },
  badge: {
    position: "absolute",
    zIndex: 10,
    top: -3,
    right: -3,
  },
});
